import { RolesKeyType } from 'constant/roles'
import { lazy } from 'react'
import { approvalInjectionRBAC } from 'features/Payment/pages/ApprovalInjection/rbac'
import { paymentGatewayRBAC } from 'features/Payment/pages/PaymentGatewayAdmin/rbac'
import { PaymentDashboardRBAC } from 'features/Payment/pages/PaymentDashboard/List/rbac'
import { PaymentDashboardDetailRBAC } from 'features/Payment/pages/PaymentDashboard/Detail/rbac'
import { disbursmentRBAC } from 'features/Payment/pages/Disbursement/rbac'
import { refundRBAC } from 'features/Payment/pages/Refund/rbac'

import generateRouterDetail from 'utils/helpers/generateRouterDetail'

const ApprovalInjection = lazy(() => import('../pages/ApprovalInjection'))
const PaymentGatewayAdmin = lazy(() => import('../pages/PaymentGatewayAdmin'))
const PaymentDashboardList = lazy(() => import('../pages/PaymentDashboard/List'))
const PaymentDashboardDetail = lazy(() => import('../pages/PaymentDashboard/Detail'))
const Disbursement = lazy(() => import('../pages/Disbursement'))
const Refund = lazy(() => import('../pages/Refund'))

export const ApprovalInjectionRouter: RouterFeatureInterface<
  'ApprovalInjectionRouter',
  '/dashboard/approval-injection'
> = {
  name: 'ApprovalInjectionRouter',
  Component: ApprovalInjection,
  path: '/dashboard/approval-injection',
  routeType: 'PRIVATE',
  allowedRoles: [],
  isDashboard: true,
  rbacPageID: approvalInjectionRBAC.pageID,
}

export const PaymentGatewayAdminRouter: RouterFeatureInterface<
  'PaymentGatewayAdmin',
  '/dashboard/payment-gateway-admin'
> = {
  name: 'PaymentGatewayAdmin',
  Component: PaymentGatewayAdmin,
  path: '/dashboard/payment-gateway-admin',
  routeType: 'PRIVATE',
  rbacPageID: paymentGatewayRBAC.pageID,
  allowedRoles: [],
  isDashboard: true,
}
export const DisbursementRouter: RouterFeatureInterface<'Disbursement', '/dashboard/disbursement'> =
  {
    name: 'Disbursement',
    Component: Disbursement,
    path: '/dashboard/disbursement',
    routeType: 'PRIVATE',
    rbacPageID: disbursmentRBAC.pageID,
    allowedRoles: [],
    isDashboard: true,
  }

export const PaymentDashboardListRouter: RouterFeatureInterface<
  'PaymentDashboardListRouter',
  '/dashboard/payment-dashboard/list'
> = {
  name: 'PaymentDashboardListRouter',
  Component: PaymentDashboardList,
  path: '/dashboard/payment-dashboard/list',
  routeType: 'PRIVATE',
  rbacPageID: PaymentDashboardRBAC.pageID,
  allowedRoles: [],
  isDashboard: true,
}

export const PaymentDashboardDetailRouter: RouterFeatureInterface<
  'PaymentDashboardDetailRouter',
  '/dashboard/payment-dashboard/detail/:id'
> = {
  name: 'PaymentDashboardDetailRouter',
  Component: PaymentDashboardDetail,
  path: '/dashboard/payment-dashboard/detail/:id',
  routeType: 'PRIVATE',
  rbacPageID: PaymentDashboardDetailRBAC.pageID,
  allowedRoles: [],
  isDashboard: true,
}

export const RefundRouter: RouterFeatureInterface<'Refund', '/dashboard/refund'> = {
  name: 'Refund',
  Component: Refund,
  path: '/dashboard/refund',
  routeType: 'PRIVATE',
  rbacPageID: refundRBAC.pageID,
  allowedRoles: [],
  isDashboard: true,
}

export const roleAllowedForUpdatePaymentGateway: RolesKeyType[] = [
  'AUTH_HO_PRODUCT_MANAGER',
  'AUTH_HO_QUALITY_ENGINEERING',
]

const PaymentRouter = [
  ApprovalInjectionRouter,
  PaymentGatewayAdminRouter,
  PaymentDashboardListRouter,
  PaymentDashboardDetailRouter,
  DisbursementRouter,
  RefundRouter,
]

export const PaymentRouterDetail = generateRouterDetail(PaymentRouter)

export default PaymentRouter
